import React, { useRef, useState } from 'react';
import { FilterSectionStoryblok } from '../../types/storyblok';
import { Box } from '../../base/Box/Box';
import renderStoryblokComponents from '../../utils/renderStoryblokComponents';
import * as Accordion from '@radix-ui/react-accordion';
import { Filters } from './components/Filters';
import { useCloseOnOutsideClick } from './hooks/useCloseOnOutsideClick';

const FilterSection = ({
  filters,
  sections,
  colourScheme,
}: FilterSectionStoryblok) => {
  const [filterState, setFilterState] = useState({});
  const [open, setOpen] = useState('');
  const accordionRef = useRef(null);

  useCloseOnOutsideClick(accordionRef, setOpen);

  return (
    <>
      <Box as="div" className="repeating-border-section w-full mb-8">
        <Box as="div" className="max-w-standard mx-auto px-5 xl:px-0">
          <Accordion.Root
            type="single"
            collapsible
            value={open}
            onValueChange={setOpen}
            className="flex items-center"
          >
            <div ref={accordionRef}>
              <Filters
                filters={filters}
                open={open}
                colourScheme={colourScheme?.toString()}
                filterState={filterState}
                setOpen={setOpen}
                setFilterState={setFilterState}
              />
            </div>
          </Accordion.Root>
        </Box>
      </Box>
      {!!sections?.length &&
        renderStoryblokComponents({
          blocks: sections,
          preProps: {},
          postProps: filterState,
        })}
    </>
  );
};

export default FilterSection;
